import React from "react";
import { getSellCenterFeatureStatus } from "../../../utils/sellCenterStatus";
import { elakayAutoText } from "../../pageInside/dataElakay";

// Muted, non-shouty status presentation (redesign ticket §16) -- a small dot + "Available" for
// the common case, plain text (no dot) for the exception states. Still 100% driven by the
// existing AnimationSettings lookup (getSellCenterFeatureStatus); never a fabricated status, and a
// group with no existing featureKey renders nothing at all (same rule as before the redesign).
const RoleStatusBadge = ({ group, plan, allSettings }) => {
  if (!group.featureKey) return null;
  const status = getSellCenterFeatureStatus(allSettings, group.featureKey, plan.roleName);
  const badgeKey =
    status === "soon"
      ? "h_userstep_status_soon"
      : status === "coming_back"
        ? "h_userstep_status_comingback"
        : "h_userstep_status_active";
  const badgeFallback = status === "soon" ? "Coming Soon" : status === "coming_back" ? "Coming Back" : "Available";

  return (
    <span className={`userstep-group-status userstep-group-status--${status}`}>
      {status === "active" && (
        <span className="userstep-group-status-dot" aria-hidden="true">●</span>
      )}
      {elakayAutoText(badgeKey, badgeFallback)}
    </span>
  );
};

export default RoleStatusBadge;
